import { Link } from "react-router-dom";
import { Sparkles, Bot } from "lucide-react";
import { useEffect, useState } from "react";
import AdminAiSearchPanel from "@/components/AdminAiSearchPanel";
import AiOrchestratorPanel from "@/components/AiOrchestratorPanel";
import { getAuthHeaders } from "@/lib/auth-fetch";
import { API_BASE } from "@/lib/utils";

export default function AiSearch() {
  const [aiEnabled, setAiEnabled] = useState(false);
  const [tab, setTab] = useState("aivoryone");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${API_BASE}/api/admin/capabilities`, {
          cache: "no-store",
          headers: getAuthHeaders(),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) return;
        if (cancelled) return;
        const flags = data?.featureFlags || {};
        const features = data?.features || [];
        const plan = String(data?.plan || "").toLowerCase();
        setAiEnabled(
          data?.grandfathered === true
          || flags.ai_search === true
          || features.includes("ai_search")
          || plan === "enterprise"
          || plan === "scale",
        );
      } catch {
        if (!cancelled) setAiEnabled(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="p-4 md:p-8 lg:p-12 max-w-4xl mx-auto" data-testid="ai-search-page">
      <div className="mb-8">
        <div className="flex items-center gap-2 text-[var(--primary)] mb-2">
          <Sparkles size={18} />
          <span className="text-[10px] font-mono uppercase tracking-widest">Aivory AI</span>
        </div>
        <h1 className="text-2xl font-semibold text-[var(--text-primary)]">AI workspace</h1>
        <p className="mt-2 text-sm text-[var(--text-secondary)] max-w-2xl">
          <strong>AivoryONE (Beta)</strong> completes multi-step setup in your tenant (events, registration, landing pages, comms).
          <strong> Search</strong> finds attendees, help, and templates.
        </p>
        {!aiEnabled ? (
          <p className="mt-3 text-sm">
            <Link to="/admin/billing" className="text-[var(--primary)] underline underline-offset-2">
              Upgrade to Studio
            </Link>
            {" "}to unlock AI features.
          </p>
        ) : null}
      </div>

      <div className="flex gap-2 mb-6">
        <button
          type="button"
          className={`btn-secondary text-sm flex items-center gap-2 ${tab === "aivoryone" ? "!border-[var(--primary)]" : ""}`}
          onClick={() => setTab("aivoryone")}
        >
          <Bot size={14} />
          AivoryONE (Beta)
        </button>
        <button
          type="button"
          className={`btn-secondary text-sm flex items-center gap-2 ${tab === "search" ? "!border-[var(--primary)]" : ""}`}
          onClick={() => setTab("search")}
        >
          <Sparkles size={14} />
          Search
        </button>
      </div>

      {tab === "aivoryone" ? (
        <AiOrchestratorPanel aiEnabled={aiEnabled} />
      ) : (
        <AdminAiSearchPanel aiEnabled={aiEnabled} autoFocus />
      )}
    </div>
  );
}
